module.exports = __webpack_public_path__ + "img/gr8table-white.9450f0be.png";